function markImageLoaded(img) {
  if (!img.classList.contains('loaded')) {
    img.classList.add('loaded');
  }
}

function initImages(scope = document) {
  const images = scope.querySelectorAll('img');

  images.forEach(img => {
    // Already cached
    if (img.complete && img.naturalWidth !== 0) {
      markImageLoaded(img);
    } else {
      img.addEventListener('load', () => markImageLoaded(img), { once: true });
      img.addEventListener('error', () => markImageLoaded(img), { once: true });
    }
  });
}

// Initial run
initImages();

// Watch for Shopify dynamic content (variants, sections, recommendations, etc.)
new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;

      if (node.tagName === 'IMG') {
        initImages(node.parentNode);
      } else {
        initImages(node);
      }
    });
  });
}).observe(document.body, {
  childList: true,
  subtree: true
});